import React, { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import client from "../lib/api";
import { useCart } from "../context/CartContext";

const DAYS = ["Breakfast", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

const MealCard = ({ item }) => {
  const { requestAdd } = useCart();
  return (
    <div className="rounded-2xl bg-[#f6ece0] overflow-hidden shadow-sm">
      {item.image && (
        <img src={item.image} alt={item.name} className="w-full h-52 object-cover" loading="lazy" />
      )}
      <div className="p-4">
        {item.special && (
          <span className="inline-block mb-2 text-xs font-semibold text-white bg-[#9a4a2f] rounded-full px-3 py-1">{item.special}</span>
        )}
        <div className="flex justify-between items-start gap-3">
          <h3 className="font-heading text-xl font-bold text-[#2c1e12] leading-snug">{item.name}</h3>
          <span className="text-[#9a4a2f] font-bold whitespace-nowrap">${item.price.toFixed(2)}</span>
        </div>
        <p className="text-sm text-[#8a7458] mt-1">{item.desc}</p>
        <button onClick={() => requestAdd({ id: item.id, name: item.name, price: item.price, image: item.image })}
          className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-[#9a4a2f] hover:bg-[#853e26] text-white text-sm font-semibold px-4 py-2 transition-colors">
          <Plus className="h-4 w-4" /> Add to Cart
        </button>
      </div>
    </div>
  );
};

const Menu = () => {
  const [menu, setMenu] = useState(null);
  const [avail, setAvail] = useState([]);
  const [tab, setTab] = useState("Monday");

  useEffect(() => {
    client.get("/menu").then((r) => setMenu(r.data)).catch(() => {});
    client.get("/menu/availability").then((r) => setAvail(r.data.days)).catch(() => {});
  }, []);

  const dateFor = (weekday) => avail.find((d) => d.weekday === weekday);

  const list = !menu ? [] : tab === "Breakfast" ? menu.breakfast : (menu.weekly[tab] || []);

  return (
    <div className="max-w-3xl mx-auto px-4 pt-20 pb-24">
      <h1 className="font-heading text-4xl font-bold text-[#2c1e12]">Weekly Menu</h1>
      <p className="text-[#8a7458] mt-1">Breakfast & lunch, freshly made Mon–Fri</p>

      <div className="flex gap-2 overflow-x-auto mt-5 pb-2 -mx-4 px-4">
        {DAYS.map((d) => {
          const info = dateFor(d);
          const closed = d !== "Breakfast" && info && !info.orderable;
          return (
            <button key={d} onClick={() => setTab(d)}
              className={`whitespace-nowrap rounded-full px-5 py-2 text-sm font-medium transition-colors ${
                tab === d ? "bg-[#9a4a2f] text-white" : "bg-[#efe3cd] text-[#4a3524] hover:bg-[#e6d6b8]"
              }`}>
              {d}{closed ? " · closed" : ""}
            </button>
          );
        })}
      </div>

      {(() => {
        const info = dateFor(tab);
        if (tab !== "Breakfast" && info) {
          return (
            <p className={`mt-3 text-sm ${info.orderable ? "text-[#2c6e49]" : "text-[#9a4a2f]"}`}>
              {info.orderable
                ? `Ordering open for ${tab}, ${info.date} — order before 10 PM the day before.`
                : `Ordering for the next ${tab} has closed. You can order for upcoming days.`}
            </p>
          );
        }
        if (tab === "Breakfast") return <p className="mt-3 text-sm text-[#8a7458]">Available every weekday. Add to cart and pick your day at checkout.</p>;
        return null;
      })()}

      <div className="grid sm:grid-cols-2 gap-4 mt-5">
        {list.map((item) => <MealCard key={item.id} item={item} />)}
      </div>
    </div>
  );
};

export default Menu;
